import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import logTraffic from "./logTraffic";

export default function TrafficTracker() {
  const location = useLocation();

  useEffect(() => {
    if (/^\/(admin|login)(\/|$)/i.test(location.pathname)) return undefined;
    if (location.pathname === "/client-portal" && new URLSearchParams(location.search).get("preview") === "1") return undefined;
    const timer = setTimeout(() => {
      const safeSearch = new URLSearchParams(location.search);
      safeSearch.delete("continuation");
      logTraffic({ route: location.pathname, search: safeSearch.toString() ? `?${safeSearch}` : "" });
    }, 150);

    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
}
